import headshot from '../../assets/wbates.headshot.png';
import './Hero.css';

const Hero = () => {
  const scrollTo = (e, id) => {
    e.preventDefault();
    document.querySelectorAll('.fade-in').forEach((n) => n.classList.add('visible'));
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="hero" id="hero">
      <div className="hero__inner container">
        <div className="hero__text">
          <h1 className="hero__name">Bill Bates</h1>
          <p className="hero__title">Technology Executive &amp; Fractional CTO</p>
          <p className="hero__summary">
            25+ years scaling engineering organizations, driving agile transformation,
            and building products that matter.
          </p>
          <div className="hero__ctas">
            <a
              href="#contact"
              className="hero__btn hero__btn--primary"
              onClick={(e) => scrollTo(e, 'contact')}
            >
              Get in Touch
            </a>
            <a
              href="#projects"
              className="hero__btn hero__btn--ghost"
              onClick={(e) => scrollTo(e, 'projects')}
            >
              View Projects
            </a>
          </div>
        </div>
        <div className="hero__image-wrap">
          <img
            src={headshot}
            alt="Bill Bates"
            className="hero__headshot"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
